import { SitecoreDictionaryPhrase } from '../models';

/**
 * Type guard to check if a field is a Sitecore dictionary item (has a Phrase or PhraseShared field).
 *
 * @param field - The field to check.
 * @returns True if the field is a dictionary item, otherwise false.
 */
export const isDictionaryField = (
  field: unknown
): field is Record<string, SitecoreDictionaryPhrase> => {
  if (typeof field !== 'object' || field === null || !('fields' in field)) {
    return false;
  }

  const fields = (field as Record<string, unknown>).fields as SitecoreDictionaryPhrase;
  if (typeof fields !== 'object' || fields === null) {
    return false;
  }

  return 'Phrase' in fields || 'PhraseShared' in fields;
};
